<div class="refund-teaser-container">
  <h2 class="refx-display-3 refund-teaser-title" [innerHTML]="customRefundTeaserTitle ? customRefundTeaserTitle : translations.title | o3rTranslate"></h2>
  <span class="refx-body-1 refund-teaser-body">
    <span
      [innerHTML]="customRefundTeaserBody ? customRefundTeaserBody : showAmount && showRefundAmount && !!refundAmount?.value && !isPartialRefundEnabled ? (translations.bodyWithAmount | o3rTranslate : {
        refundAmount: refundAmount?.value
      }) : translations.bodyNoAmount | o3rTranslate"
    >
    </span>
  </span>
  <div class="button-panel">
    <custom-back-to-mmb-pres
      class="refund-teaser-button"
      [flavor]="'refund'"
    ></custom-back-to-mmb-pres>
  </div>
</div>
